import { useSelector } from 'react-redux';

const useTasks = () => {
  const { pending, completed, scheduled, archived } = useSelector((state) => state.taskSlice);

  return {
    pending,
    completed,
    scheduled,
    archived,
  };
};

export default useTasks;
